import { parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'
import { RolodexEntryJson, RolodexEntryType } from './rolodexEntryFields'

/**
 * An entry that holds an Observation taken from site - right now uesed for adding indications to point clouds
 */
export class GeckoGeographicPin extends GeckoEntryBase<
  {
    name: string | undefined
    geo_json: GeoJSON.Feature
  },
  {
    site: string
    organization: string
    [RolodexEntryType.UNIT]?: string
    [RolodexEntryType.REPORT]?: string
    [RolodexEntryType.POTREE_POINT_CLOUD]?: string
  }
> {
  //----------------------------------------------------------------------------

  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        name: parseString(json.data.name),
        geo_json: json.data.geo_json as GeoJSON.Feature,
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        [RolodexEntryType.POTREE_POINT_CLOUD]: parseString(
          json.tags[RolodexEntryType.POTREE_POINT_CLOUD]
        ),
        [RolodexEntryType.UNIT]: parseString(json.tags[RolodexEntryType.UNIT]),
        [RolodexEntryType.REPORT]: parseString(
          json.tags[RolodexEntryType.REPORT]
        ),
      },
      {}
    )
  }

  //----------------------------------------------------------------------------

  /**
   * A simple factory method which creates a point cloud from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoGeographicPin(json)
  }
}
